import script from "./Column.vue?vue&type=script&setup=true&lang=ts"
export * from "./Column.vue?vue&type=script&setup=true&lang=ts"

import "./Column.vue?vue&type=style&index=0&id=37c43327&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37c43327"]])

export default __exports__